import React from 'react';
import { Row } from 'antd';
import cn from 'classnames';
import styles from './FormRow.module.scss';

const FormRow = ({ className, rowType = 'row', ...props }) => {
  return <Row {...props} className={cn(styles.root, className, {
    [styles.row]: rowType === 'row',
    [styles.subtitle]: rowType === 'subtitle',
    [styles.field]: rowType === 'field',
  })} />;
};

export default FormRow;
